// alert
import alert from '@drivesally/sally-ui/lib/libs/alert';

// branch api
import updateBranchApi from '@drivesally/sally-fn/lib/branch/api/update.api.branch';

// branch components
import BranchSupportHoursModal from '../../components/BranchSupportHoursModal/BranchSupportHoursModal';

// error lib
import parseError from '@drivesally/sally-fw/lib/error/parseError';

// propTypes
import PropTypes from 'prop-types';

// react
import React, {Component} from 'react';

class BranchSupportHoursModalContainer extends Component {
  static propTypes = {
    branch: PropTypes.object,
    onClose: PropTypes.func,
    setData: PropTypes.func,
    visible: PropTypes.bool,
  };

  state = {
    refresh: 0,
    saving: false,
    support_hours: {},
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.visible && this.props.visible) this.bootstrap();
  }

  bootstrap = () => {
    const {branch} = this.props;
    this.setState({
      refresh: new Date().getTime(),
      support_hours: {...(branch?.support_hours || {})},
    });
  };

  change = (day) => (value) => {
    this.setState((prev) => ({
      support_hours: {
        ...prev.support_hours,
        [day]: value[day]?.open || [],
      },
    }));
  };

  save = async () => {
    const {branch, onClose, setData} = this.props;
    const {saving, support_hours} = this.state;
    if (saving || !branch?.id) return;
    this.setState({saving: true});
    try {
      const updatedBranch = await updateBranchApi(branch.id, {
        support_hours,
      });
      if (!!setData)
        setData({branch: updatedBranch, originalBranch: updatedBranch});
      this.setState({saving: false});
      onClose();
    } catch (error) {
      const {message} = parseError(error);
      alert.error(message);
      this.setState({saving: false});
    }
  };

  render() {
    const {branch, onClose, visible} = this.props;
    const {refresh, saving, support_hours} = this.state;
    return (
      <BranchSupportHoursModal
        onChange={this.change}
        onClose={onClose}
        onSave={this.save}
        refresh={refresh}
        saving={saving}
        supportHours={support_hours}
        title={branch?.name}
        visible={visible}
      />
    );
  }
}

export default BranchSupportHoursModalContainer;
